import React from "react";
import { UseGlobalState } from "../../state/gsh/gsh";

import { debugLog } from "../../util/debug";
import Auth from "../auth/Auth";


export default function TabShop() {
    const [state, setState] = UseGlobalState()

    React.useEffect(() => {
        debugLog('TabShop useEffect')
        if (!!!state.tabQueryString) {
            state.tabQueryString = '&redirectUrl=/shop-rewards';
            setState(state);
        }
      }, 
      // eslint-disable-next-line react-hooks/exhaustive-deps
      [state]);

    return (
        <div className="App">
            <Auth destination="/tabdirect" tabView={true} />
        </div>
    )
}